module.exports = __webpack_public_path__ + "static/media/RVTN02.72fa4882.jpg";